export const ACCOUNT_SUB_TYPE_ALT_TEXT = {
  FLEX_BASIC: "Flex Basic",
  FLEX_ACCOUNT: "Flex Account",
  FLEX_PLUS: "Flex Plus",
  FLEX_DIRECT: "Flex Direct",
  FLEX_ONE: "Flex One",
  FLEX_STUDENT: "Flex Student",
  FLEX_GRADUATE: "Flex Graduate",
};
export const DEBIT_CARD = "Debit Card";
export const ERROR_MESSAGE = {
  HEADING: "Sorry, something has gone wrong",
  SUB_HEADING:
    "There is a technical issue that is not your fault. We are working on fixing it.",
};
export const FULLY_AUTHENTICATED = "fully authenticated";
export const GAMBLING = "GAMBLING";
export const GAMBLING_CONTROLS = "Gambling controls";
export const INVERSTOR_TYPE_CODE = {
  JOINT_HOLDER: "1",
  SINGLE_HOLDER: "0",
};
export const MESSAGE_HEADING_TYPE = {
  INFORMATION: "Information",
  NOTE: "Note",
};
export const MESSAGE_TYPE = {
  INFO: "info",
  WARNING: "warning",
};
export const PAGE_LOADING = "Page Loading";
export const REQUEST_TYPE = {
  GET: "GET",
  SET: "SET",
};
export const SF_COMMUNICATION = {
  EVENTS: {
    ON_START: "onStart",
    SET_HEIGHT: "setHeight",
    SET_TITLE: "setTitle",
    SET_CONTAINER_CONFIG: "setContainerConfig",
    SHOW_MODAL: "showModal",
  },
  IFRAME_HEIGHT: 400,
  METHODS: {
    ON_START_CALLBACK: "onStart_callback",
    SHOW_MODAL_CALLBACK: "showModal_callback",
  },
};

export const TRACKING_CONTEXT = {
  ACCOUNT_TYPE: {
    IDENTIFIER: "account_type",
    VALUE: {
      FLEX_ONE: "flexone",
      FLEX_BASIC: "flexbasic",
      FLEX_ACCOUNT: "flexaccount",
      FLEX_PLUS: "flexplus",
      FLEX_DIRECT: "flexdirect",
      FLEX_STUDENT: "flexstudent",
      FLEX_GRADUATE: "flexgraduate",
    },
  },
  BLOCK_STATUS: {
    IDENTIFIER: "block_status",
  },
  DYNAMIC_MESSAGE: {
    ERROR: "something has gone wrong",
    BUTTON_INTERACTION: "button interaction",
    TOGGLE_INTERACTIONS: "toggle interactions",
    TOGGLE_OFF_TEXT: "turn off gambling block",
    TOGGLE_ON_TEXT: "turn on gambling block",
  },
  GAMBLING_CONTROLS: "gambling_controls",
  INVESTOR_TYPE: {
    IDENTIFIER: "investor_type",
    VALUE: {
      JOINT: "joint",
      SOLE: "sole",
    },
  },
  NAVIGATION_TYPE: {
    LINK: "link",
    PRIMARY_BUTTON: "primary button",
    TOGGLE_SWITCH: "toggle switch",
  },
  PAGE: {
    BLOCKED: "blocked",
    CONFIRM_BLOCK: "confirm_block",
    CONFIRM_UNBLOCK: "confirm_unblock",
    ERROR: "error",
    LOADER: "loader",
    NOT_BLOCKED: "not_blocked",
    NULL: "null",
    PREFIX: "ib:otheraccountservices:gambling_controls:",
    UNBLOCK_PENDING: "unblock_pending",
  },
};

export const VISA = "Visa";
